import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useTabActions } from '../../contexts/tab-navigation';
import { useApprovalNotifications } from '../../hooks/useApprovalNotifications';
import RaporTemsilciOnay from '../../pages/RAPOR_TEMSILCI_ONAY/rapor_temsilci_onay';

const buttonStyle = {
  border: '1px solid #f2dcdc',
  borderRadius: 6,
  background: '#fdf0f0',
  color: '#b64b4b',
  fontWeight: 600,
  fontSize: 12,
  lineHeight: 1.15,
  minHeight: 30,
  height: 'auto',
  padding: '4px 9px',
  cursor: 'pointer',
  whiteSpace: 'normal',
  maxWidth: '100%',
};

const countStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 18,
  height: 18,
  marginLeft: 5,
  padding: '0 5px',
  borderRadius: 10,
  background: '#c62828',
  color: '#fff',
};

export default function ApprovalNotificationBadge() {
  const { summary } = useApprovalNotifications();
  const { openDetailTab } = useTabActions();
  const history = useHistory();

  const open = useCallback((scope) => {
    const review = scope === 'review';
    openDetailTab(
      `approval-${scope}`,
      review ? 'Onay Bekleyenler' : (summary.genel_yetkili ? 'Onay Cevapları' : 'Onay Cevaplarım'),
      RaporTemsilciOnay,
      { initialScope: scope },
    );
    if (history.location?.pathname !== '/home') history.push('/home');
  }, [history, openDetailTab, summary.genel_yetkili]);

  return <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 16, maxWidth: '100%' }}>
    {summary.genel_yetkili && (
      <button type="button" style={buttonStyle} onClick={() => open('review')} title="Bekleyen yönetici onayları">
        Onaylar <span style={countStyle}>{summary.onay_sayisi}</span>
      </button>
    )}
    <button type="button" style={{ ...buttonStyle, color: '#286da6', borderColor: '#d8e8f6', background: '#edf5fc' }} onClick={() => open('mine')}
      title={summary.genel_yetkili ? 'Sonuçlanan onaylar' : 'Sonuçlanan onay taleplerim'}>
      Cevaplar <span style={{ ...countStyle, background: '#1565c0' }}>{summary.cevap_sayisi}</span>
    </button>
  </div>;
}
